import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../ui/dialog';
import { Button } from '../ui/button';
import { Loader2, Trash2 } from 'lucide-react';
import { toast } from 'sonner';
import api from '../../utils/axios';

export const EliminarCasosDialog = ({ open, onOpenChange, caseIds, onDone }) => {
  const [enviando, setEnviando] = useState(false);
  const n = caseIds.length;

  const confirmar = async () => {
    setEnviando(true);
    try {
      const r = await api.post('/cases/papelera/enviar', { ids: caseIds });
      toast.success(`${r.data.movidos} caso(s) enviados a la papelera con ${r.data.alertas} alerta(s)`);
      onOpenChange(false);
      onDone?.();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'No se pudieron eliminar los casos');
    } finally { setEnviando(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="eliminar-casos-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-red-700"><Trash2 size={18} /> Eliminar {n} caso{n === 1 ? '' : 's'}</DialogTitle>
          <DialogDescription>
            Los casos van a la papelera <b>junto con sus alertas</b>. Podés recuperarlos durante 30 días; después se borran solos.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} disabled={enviando}>Cancelar</Button>
          <Button onClick={confirmar} disabled={enviando || !n} className="bg-red-600 hover:bg-red-700 text-white" data-testid="eliminar-casos-confirmar">
            {enviando && <Loader2 size={15} className="mr-1.5 animate-spin" />} Enviar a la papelera
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default EliminarCasosDialog;
